<main class="w-full">
  @if (showLabel) {
  <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1">
    {{ label }}
    @if (isRequired) {
    <span class="text-error ml-0.5">*</span>
    }
  </label>
  }

  <div class="relative w-full">
    <input [type]="type" [placeholder]="placeholder" [value]="value" [disabled]="isDisabled" [readonly]="readonly"
      [attr.maxLength]="maxlength" (input)="onInput($event)" [ngStyle]="{ 'background-color': inputBackgroundColor }"
      [autocomplete]="'autocomplete'" class="w-full h-10 px-3 pr-9 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded text-xs text-slate-900 dark:text-white placeholder-slate-400
      focus:outline-none focus:ring-1 focus:ring-slate-400 dark:focus:ring-slate-500 focus:border-slate-500 dark:focus:border-slate-400
      disabled:bg-slate-50 dark:bg-slate-800/60 disabled:cursor-not-allowed disabled:text-slate-400
      transition-colors" />
    <img [src]="image()" alt="icon" (click)="onView()"
      class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 cursor-pointer opacity-40 hover:opacity-70 dark:invert transition-opacity">
  </div>
</main>